import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
    selector: 'cp-import-grid-tooltip',
    templateUrl: './import-grid-tooltip.component.html',
    styleUrls: ['./import-grid-tooltip.component.scss'],
    standalone: false
})
export class CpImportGridTooltipComponent implements ITooltipAngularComp {

    params : Object;

    agInit (params : ITooltipParams<any, any, any>) : void {
        for (let propName in params.data) {
            if (params.data.hasOwnProperty(propName)) {
                this.params = params.data[propName];
            }
        }   
    }
}
